<!-- 日历排课 -->
<template>
    <div class="home">
        <div class="home-content">
            <!-- <div class="block-title">课表</div> -->
            <div class="home-content-top mt-20">
                <div class="tabs ">
                    <div v-for="(item, index) in tabsList" :key="index" :class="index === tabsActive ? 'active' : ''" @click="changeTabs(index)">{{item}}</div>
                </div>
                <div v-if="tabsActive === 0" class="change-date flex ai-c">
                    <img class="mr-20" src="@/assets/measAssets/image/common/left.png" alt="" @click="changeDay(1)">
                    <span class="mr-20">{{dayTime}}</span>
                    <img class="mr-20" src="@/assets/measAssets/image/common/right.png" alt="" @click="changeDay(2)">
                    <p class="color-brand pointer fs-medium" @click="changeDay(3)">今日</p>
                </div>
                <div v-if="tabsActive === 1" class="change-date flex ai-c">
                    <img class="mr-20" src="@/assets/measAssets/image/common/left.png" alt="" @click="changeWeek(1)">
                    <span class="mr-20">{{weekModelStr}}</span>
                    <img class="mr-20" src="@/assets/measAssets/image/common/right.png" alt="" @click="changeWeek(2)">
                    <p class="color-brand pointer fs-medium" @click="changeWeek(3)">本周</p>
                </div>
                <div v-if="tabsActive === 2" class="change-date flex ai-c">
                    <img class="mr-20" src="@/assets/measAssets/image/common/left.png" alt="" @click="changeMonth(1)">
                    <span class="mr-20">{{monthModelDate}}</span>
                    <img class="mr-20" src="@/assets/measAssets/image/common/right.png" alt="" @click="changeMonth(2)">
                    <p class="color-brand pointer fs-medium" @click="changeMonth(3)">本月</p>
                </div>
                <el-button>时间轴设置</el-button>
            </div>
            <div class="mt-20" v-if="tabsActive === 0">
                <CalendarDay :datalist="dayList" @editClass="editClass" @delCourse="delCourse" :dayTime="dayTime"></CalendarDay>
            </div>
            <div v-show="tabsActive === 1" class="mt-20">
                <CalendarMonth :datalist="dayList" :info="dayInfo" modle="week" ref="CalendarWeek" @getweek="getWeek" />
            </div>
            <div v-show="tabsActive === 2" class="mt-20">
                <CalendarMonth :info="dayInfo" ref="CalendarMonth" @delCourse="delCourse" @editClass="editClass" @getDate="getDate" />
            </div>
        </div>
        <!-- 课时编辑 -->
        <ClassEdit ref="ClassEdit" />
    </div>

</template>

<script>
import { getScheduleByCal } from '@/api/measApi/index.js'
import { updateCourseperiodStatus } from '@/api/measApi/teachManagement.js'
import CalendarDay from '@/views/meas/index/components/calendarDay.vue'
import CalendarMonth from './dateModle/calendarMonth.vue'
import { dateFormat2 } from '@/assets/measAssets/js/tools.js'
import ClassEdit from '@/views/meas/teachManagement/classManagement/components/classEdit'
export default {
  data() {
    return {
      summaryInfo: {}, // 汇总信息
      params: {
        campuscode: '', // 校区code
        classcode: '', // 班级code
        classcoursecode: '', // 课程code
        enddate: '',
        startdate: ''
      },
      tabsList: ['日', '周', '月'],
      tabsActive: 0,
      dayList: [],
      dayInfo: [],
      dayTime: '',
      monthModelDate: '',
      weekModelStr: ''
    }
  },
  props: {
    // 班级code
    classCode: {
        type : String,
        require: false
    },
    // 课程code
    classcoursecode: {
        type : String,
        require: false
    }
  },
  components: {
    CalendarDay,
    CalendarMonth,
    ClassEdit
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.getScheduleByCal()
  },
  watch: {
    dayTime: {
      handler(newval) {
        if (newval) {
          this.dayInfo.map(item => {
            if (item.perioddate === newval) {
              this.dayList = item.datalist
            }
          })
        }
      }
    }
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    //   获取课表信息
    getScheduleByCal() {
        this.params.classcode = this.classCode
        this.params.classcoursecode = this.classcoursecode
      getScheduleByCal(this.params).then(res => {
        if (res.code === '000') {
          this.dayInfo = res.data
          this.dayTime = dateFormat2(new Date())
        }
      })
    },
    // 切换模式
    changeTabs(index) {
      this.tabsActive = index
    },
    // 昨天
    changeDay(args) {
      this.dayList = []
      if (args === 1) {
        this.dayTime = dateFormat2(
          new Date(new Date(this.dayTime).getTime() - 24 * 60 * 60 * 1000 * 1)
        )
      } else if (args === 2) {
        this.dayTime = dateFormat2(
          new Date(new Date(this.dayTime).getTime() + 24 * 60 * 60 * 1000 * 1)
        )
      } else {
        this.dayTime = dateFormat2(new Date())
      }
    },
    changeMonth(args) {
      if (args === 1) {
        this.$refs.CalendarMonth.changePrvM()
      } else if (args === 2) {
        this.$refs.CalendarMonth.changeNextM()
      } else {
        this.$refs.CalendarMonth.init()
      }
    },
    changeWeek(args) {
      if (args === 1) {
        this.$refs.CalendarWeek.getPrvWeek()
      } else if (args === 2) {
        this.$refs.CalendarWeek.getNextWeek()
      } else {
        this.$refs.CalendarWeek.init()
      }
    },
    getDate(month, year) {
      this.monthModelDate = year + '-' + month
    },
    getWeek(weekInfo) {
      console.log(weekInfo, 'weekInfo')
      this.weekModelStr = weekInfo[0] + '-' + weekInfo[weekInfo.length - 1]
    },
    // 课时编辑
    editClass(row) {
      console.log(row, 'row')
      this.$refs.ClassEdit.init(row.code)
    },
    // 课时删除
    delCourse(row) {
      this.$confirm('删除该课时后将影响当日课时安排，继续吗？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      }).then(() => {
        updateCourseperiodStatus({ codes: row.code, status: 100 }).then(res => {
          if (res.code === '000') {
            this.$message.success(res.msg)
            this.getScheduleByCal()
            this.$refs.CalendarMonth.init()
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.home .is-vertical {
  min-width: none !important;
}
.el-scrollbar__bar,
.is-vertical {
  top: 0 !important;
}
.home {
  &-content {
    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tabs {
        border-radius: 4px;
        border: 1px solid #e4e7ec;
        height: 37px;
        display: flex;
        div {
          width: 52px;
          text-align: center;
          line-height: 37px;
          font-size: 12px;
          color: #66717e;
          cursor: pointer;
        }
        div:nth-child(1) {
          border-radius: 4px 0px 0px 4px;
        }
        div:nth-child(2) {
          border-right: 1px solid #e4e7ec;
          border-left: 1px solid #e4e7ec;
        }
        div:nth-child(3) {
          border-radius: 0px 4px 4px 0px;
        }
        .active {
          background: #0b75fa;
          color: #ffffff;
        }
      }
      .change-date {
        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
        span {
          color: #66717e;
          font-size: 14px;
        }
      }
    }
  }
}
</style>